<template>
  <div>
    <div class="h-166 flex row-between col-center m-b-12">
      <div :style="getBackgroundStyle(ssjeUrl)" class="width-32 height-100 flex-col row-center col-center">
        <div class="font-36 font-weight-700 m-b-20">{{ statisticsData?.receivedAmount }}<span class="font-16"> 万元</span>
        </div>
        <div class="font-24">实收金额</div>
      </div>
      <div :style="getBackgroundStyle(zcjeUrl)" class="width-32 height-100 flex-col row-center col-center">
        <div class="font-36 font-weight-700 m-b-20">{{ statisticsData?.expenseAmount }}<span class="font-16"> 万元</span>
        </div>
        <div class="font-24 m-b-2">支出金额</div>
      </div>
      <div :style="getBackgroundStyle(zlrUrl)" class="width-32 height-100 flex-col row-center col-center">
        <div class="font-36 font-weight-700 m-b-20">{{ statisticsData?.profitTotal }}<span class="font-16"> 万元</span>
        </div>
        <div class="font-24">总利润</div>
      </div>
    </div>


    <!-- 反馈分析 -->
    <div class="bg-FF p-16 m-b-12 b-r-8">
      <div class="flex space-between col-center">
        <TitleLogo></TitleLogo>
        <span class="font-32 font-weight-500">业务单元利润分布</span>
      </div>

      <div class="p-16">
        <div v-for="(item, index) in statisticsData?.profitList" :key="index" class="flex col-center row-between p-t-18 p-b-18" style="border-bottom: 1px solid #d4d5de;">
          <div class="flex col-center">
            <img v-show="index == 0" alt="rank" class="w-34 h-34 m-r-16" src="@/assets/icon/operateKanban/rank1.png" />
            <img v-show="index == 1" alt="rank" class="w-34 h-34 m-r-16" src="@/assets/icon/operateKanban/rank2.png" />
            <img v-show="index == 2" alt="rank" class="w-34 h-34 m-r-16" src="@/assets/icon/operateKanban/rank3.png" />
            <span v-show="index > 2" class="dis-in-b text-center w-34 h-34 font-28 cor-66 m-r-16">{{ index + 1 }}</span>
            <span class="font-28">{{ item.unitName }}</span>
          </div>
          <div class="width-35 flex col-center">
            <img alt="currency" class="w-36 h-36 m-r-20" src="@/assets/icon/operateKanban/money.png" />
            <span class="font-28">{{ item.profitAmount }} 万元</span>
          </div>
        </div>
      </div>
    </div>

    <!-- 年度经营指标完成情况 -->
    <div class="bg-FF p-16 m-b-12 b-r-8">
      <div class="flex space-between col-center">
        <TitleLogo></TitleLogo>
        <span class="font-32 font-weight-500">年度经营指标完成情况</span>
      </div>

      <div>
        <div class="flex col-center row-right m-t-12 m-b-12">
          <div v-for="(item,index) in jyzbSelectList" :key="index" :class="{active: jyzbActiveIndex === index }" class="font-28 h-56 l-h-56 p-l-14 p-r-14 bg-D9D9D9 cor-99 m-l-20 b-r-8" @click="clickOneSelect(index, 'jyzb')">
            {{ item.name }}
          </div>
        </div>

        <div id="jyzbBar" ref="jyzbBar" style="width: 90vw; height: 280px;"></div>
      </div>
    </div>

    <!-- 年度经营指标完成情况 -->
    <div class="bg-FF p-16 m-b-12 b-r-8">
      <div class="flex space-between col-center">
        <TitleLogo></TitleLogo>
        <span class="font-32 font-weight-500">近3年经营分析</span>
      </div>

      <div>
        <div class="flex col-center row-right m-t-12 m-b-12">
          <div v-for="(item,index) in jyfxSelectList" :key="index" :class="{active: jyfxActiveIndex === index }" class="font-28 h-56 l-h-56 p-l-14 p-r-14 bg-D9D9D9 cor-99 m-l-20 b-r-8" @click="clickOneSelect(index, 'jyfx')">
            {{ item.name }}
          </div>
        </div>

        <div id="jyfxLine" ref="jyfxLine" style="width: 90vw; height: 280px;"></div>
      </div>
    </div>
  </div>
</template>

<script>
import TitleLogo from "@/components/TitleLogo.vue";
import * as echarts from "echarts";
import echartMixin from "@/mixin/echartMixin";

export default {
  components: {TitleLogo},
  mixins: [echartMixin],
  props: {
    statisticsData: {
      type: Object,
      default: {}
    },
    paramYear: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      ssjeUrl: require('@/assets/icon/operateKanban/ssje.png'),
      zcjeUrl: require('@/assets/icon/operateKanban/zcje.png'),
      zlrUrl: require('@/assets/icon/operateKanban/zlr.png'),
      jyzbActiveIndex: 0,
      jyzbSelectList: [{name: '合同指标'}, {name: '实收指标'}, {name: '利润指标'}],
      jyzbBar: null,
      jyfxActiveIndex: 0,
      jyfxSelectList: [{name: '实收'}, {name: '支出'}, {name: '利润'}],
      jyfxLine: null,
      linexAxisData: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月']
    }
  },
  computed: {
    recentThreeYears() {
      return [this.paramYear - 2, this.paramYear - 1, this.paramYear].map(year => year.toString());
    }
  },
  watch: {
    statisticsData: {
      handler(newVal) {
        if (newVal.businessMetricsList) {
          let barLegendData = []
          let barSeriesData = []
          newVal.businessMetricsList['contractTarget'].forEach(item => {
            barLegendData.push(item.name)
            barSeriesData.push(this.getBarSeriesObj(item))
          })
          this.initJyzbBar(barLegendData, newVal.businessMetricsList.unitList, barSeriesData)

          let lineSeriesData = []
          this.recentThreeYears.forEach(item => {
            lineSeriesData.push(this.getLineSeriesObj({
              name: item,
              values: newVal.monthManageDataList.receivedList[item]
            }))
          })
          this.initJyfxLine(lineSeriesData)
        }
      },
      immediate: true // 立即执行一次，确保初始数据也能触发
    }
  },
  mounted() {
  },
  methods: {
    clickOneSelect(index, type) {
      if (type == 'jyzb') {
        this.jyzbActiveIndex = index
        let barLegendData = []
        let barSeriesData = []
        if (index == 0) {
          this.statisticsData.businessMetricsList['contractTarget'].forEach(item => {
            barLegendData.push(item.name)
            barSeriesData.push(this.getBarSeriesObj(item))
          })
        } else if (index == 1) {
          this.statisticsData.businessMetricsList['actual'].forEach(item => {
            barLegendData.push(item.name)
            barSeriesData.push(this.getBarSeriesObj(item))
          })
        } else {
          this.statisticsData.businessMetricsList['profit'].forEach(item => {
            barLegendData.push(item.name)
            barSeriesData.push(this.getBarSeriesObj(item))
          })
        }
        this.initJyzbBar(barLegendData, this.statisticsData.businessMetricsList.unitList, barSeriesData)
      } else {
        this.jyfxActiveIndex = index
        let lineSeriesData = []
        if (index == 0) {
          this.recentThreeYears.forEach(item => {
            lineSeriesData.push(this.getLineSeriesObj({
              name: item,
              values: this.statisticsData.monthManageDataList.receivedList[item]
            }))
          })
        } else if (index == 1) {
          this.recentThreeYears.forEach(item => {
            lineSeriesData.push(this.getLineSeriesObj({
              name: item,
              values: this.statisticsData.monthManageDataList.expenseList[item]
            }))
          })
        } else {
          this.recentThreeYears.forEach(item => {
            lineSeriesData.push(this.getLineSeriesObj({
              name: item,
              values: this.statisticsData.monthManageDataList.profitList[item]
            }))
          })
        }
        this.initJyfxLine(lineSeriesData)
      }
    },
    getBackgroundStyle(imgSrc) {
      return {
        'background-image': `url(${imgSrc})`,
        'background-size': 'cover',
        'background-repeat': 'no-repeat'
      }
    },
    initJyzbBar(legendData, xAxisData, seriesData) {
      const jyzbBarDom = this.$refs.jyzbBar
      if (jyzbBarDom) {
        echarts.dispose(jyzbBarDom);
        this.jyzbBar = echarts.init(jyzbBarDom);
        const option = {
          tooltip: {
            trigger: 'axis',
            confine: true
          },
          grid: {
            // top: '25%',
            left: '3%',
            right: '3%',
            bottom: '2%',
            containLabel: true
          },
          color: ['#2EC7C9', '#9491EC', '#FFD39B'],
          legend: {
            data: legendData,
            top: '2%',
            left: '2%',
            itemWidth: 15, // 设置宽度
            itemHeight: 10 // 设置高度
          },
          xAxis: [
            {
              type: 'category',
              data: xAxisData,
              axisLabel: {
                interval: 0,
                formatter: function (params) {
                  var str = "";                 // 最终拼接成的字符串
                  var paramsLen = params.length;// 获取每项文字的个数
                  var len = 3;                  // 每行能显示的字的个数（根据实际情况自己设置）
                  var rowNumber = Math.ceil(paramsLen / len); // 换行的话，需要显示几行，向上取整
                  if (paramsLen > len) {        //大于设定的len就换行，不大于就不变化
                    for (var i = 0; i < rowNumber; i++) {
                      var temp = "";            // 表示每一次截取的字符串
                      var start = i * len;      // 开始截取的位置
                      var end = start + len;    // 结束截取的位置
                      if (i == rowNumber - 1) { // 最后一次不换行
                        temp = params.substring(start, paramsLen);
                      } else {                  // 每一次拼接字符串并换行
                        temp = params.substring(start, end) + "\n";
                      }
                      str += temp;              // 最终拼成的字符串
                    }
                  } else {                      // 给新的字符串赋值
                    str = params;
                  }
                  return str;                   //返回字符串
                }
              },
              axisLine: {
                show: false
              },
              axisTick: {
                show: false
              },
            }
          ],
          yAxis: [
            {
              type: 'value',
              name: '(万元)',
              // min: 0,
              // interval: 300,
              axisLabel: {
                formatter: '{value}'
              }
            },
            {
              type: 'value',
              name: '',
              position: 'right',
              // min: 0,
              // interval: 10,
              show: false,
              axisLabel: {
                show: false,
                // formatter: '{value} %'
              },
              axisLine: {show: false}
            }
          ],
          series: seriesData
        };
        this.jyzbBar.setOption(option);

        window.addEventListener('resize', () => {
          this.jyzbBar.resize();
        });
      }
    },
    initJyfxLine(seriesData) {
      const jyfxLineDom = this.$refs.jyfxLine
      if (jyfxLineDom) {
        echarts.dispose(jyfxLineDom);
        this.jyfxLine = echarts.init(jyfxLineDom);
        const option = {
          tooltip: {
            trigger: 'axis',
            confine: true
          },
          legend: {
            data: this.recentThreeYears,
            top: '2%',
            left: '2%',
            icon: 'circle'
          },
          color: ['#6A53FE', '#2EC7C9', '#FFC03B'],
          grid: {
            // top: '20%',
            left: '5%',
            right: '4%',
            bottom: '4%',
            containLabel: true
          },
          xAxis: {
            type: 'category',
            data: this.linexAxisData,
            boundaryGap: false,
            axisLabel: {interval: 0},
            axisLine: {      // y轴
              show: false
            },
            splitLine: {     // y轴背景线
              show: true
            }
          },
          yAxis: {
            type: 'value',
            name: '(万元)',
            axisLabel: {
              formatter: '{value}'
            }
          },
          series: seriesData
        };
        this.jyfxLine.setOption(option);

        window.addEventListener('resize', () => {
          this.jyfxLine.resize();
        });
      }
    }
  },
};
</script>

<style lang="less" scoped>
.active {
  background: linear-gradient(43.9deg, #7f7efd 0%, #70a3fe 72%);
  color: #ffffff;
}
</style>
